/** Figma Method Type badge labels used across Vision display surfaces. */
export const METHOD_TYPE_BADGE_LABELS = {
  CLASS: 'Class',
} as const
